import { useEffect, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function Starfield({ reduce }) {
    const canvasRef = useRef(null);
    const { scrollY } = useScroll();
    const ySlow = useTransform(scrollY, [0, 6000], [0, reduce ? 0 : -260]);
    const yFast = useTransform(scrollY, [0, 6000], [0, reduce ? 0 : -520]);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        let raf;
        let stars = [];

        const build = () => {
            canvas.width = window.innerWidth * Math.min(window.devicePixelRatio, 2);
            canvas.height = window.innerHeight * Math.min(window.devicePixelRatio, 2);
            stars = Array.from({ length: Math.min(170, window.innerWidth / 6) }, () => ({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                r: (Math.random() * 1.4 + 0.3) * Math.min(window.devicePixelRatio, 2),
                phase: Math.random() * Math.PI * 2,
                speed: 0.4 + Math.random() * 1.1,
                gold: Math.random() > 0.72,
            }));
        };

        const draw = (t) => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (const s of stars) {
                const a = reduce ? 0.8 : 0.35 + 0.65 * Math.abs(Math.sin(t / 1000 * s.speed + s.phase));
                ctx.globalAlpha = a;
                ctx.fillStyle = s.gold ? "#F3D085" : "#EDE7F8";
                ctx.beginPath();
                ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
                ctx.fill();
            }
            ctx.globalAlpha = 1;
            if (!reduce) raf = requestAnimationFrame(draw);
        };

        build();
        draw(0);
        window.addEventListener("resize", build);
        return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", build); };
    }, [reduce]);

    return (
        <div className="pointer-events-none fixed inset-0 z-0" aria-hidden="true">
            <motion.canvas ref={canvasRef} style={{ y: ySlow }} className="absolute inset-0 h-full w-full" />
            <motion.div
                style={{ y: yFast }}
                className="absolute -top-32 left-1/2 h-[70vh] w-[120vw] -translate-x-1/2 rounded-full opacity-60"
            >
                <div className="absolute left-[8%] top-[10%] h-72 w-72 rounded-full bg-[#6B3882] opacity-25 blur-[110px]" />
                <div className="absolute right-[6%] top-[36%] h-80 w-80 rounded-full bg-[#2A1438] opacity-60 blur-[130px]" />
                <div className="absolute left-[38%] top-[52%] h-64 w-64 rounded-full bg-[#C59B27] opacity-[0.07] blur-[120px]" />
            </motion.div>
        </div>
    );
}
